module.exports = "<p-confirmDialog key=\"key\" header=\"titulo\" icon=\"fa fa-question-circle\" width=\"width\" #cd>\r\n  <p-footer>\r\n    <button id=\"dialogConfirmar\" type=\"button\" pButton icon=\"fa-check\" label=\"Sim\" (click)=\"cd.accept()\"></button>\r\n    <button id=\"dialogFechar\" type=\"button\" pButton icon=\"fa-close\" label=\"Não\" (click)=\"cd.reject()\"></button>\r\n  </p-footer>\r\n</p-confirmDialog>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/commons/ui/confirm-dialog-csi/confirm-dialog-csi.component.html
// module id = ./src/app/commons/ui/confirm-dialog-csi/confirm-dialog-csi.component.html
// module chunks = main